import { GeneralProvider } from "./context/general-context.jsx"
import Main from "./Main.js"

function App() {
    return (
        <>
            <GeneralProvider>
                <Main />
            </GeneralProvider>
        </>
    )
}

export default App;
